import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserProfile {
  id?: string;
  email: string;
  fullName?: string;
}

export interface AuthState {
  token: string | null;
  user: UserProfile | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setAuth: (token: string, user: UserProfile) => void;
  login: (token: string, user: UserProfile) => void;
  logout: () => void;
  setToken: (token: string | null) => void;
  setUser: (user: UserProfile | null) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      isLoading: false,
      setAuth: (token: string, user: UserProfile) =>
        set({ token, user, isAuthenticated: !!token }),
      login: (token: string, user: UserProfile) =>
        set({ token, user, isAuthenticated: !!token }),
      logout: () => {
        set({ token: null, user: null, isAuthenticated: false });
        if (typeof localStorage !== 'undefined') {
          localStorage.removeItem('chatagent_auth');
          localStorage.removeItem('chatagent_workspace');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      },
      setToken: (token: string | null) =>
        set({ token, isAuthenticated: !!token }),
      setUser: (user: UserProfile | null) => set({ user }),
    }),
    {
      name: 'chatagent_auth',
    }
  )
);

export const authStore = useAuthStore;
